import React from "react";

/** Fondo de la portada: placa de circuitos como el logo, con luz recorriendo las líneas. */

const TRACES = [
  "M-20 150 H300 L360 210 H620 L700 130 H1000 L1060 190 H1460",
  "M-20 330 H180 L250 400 H520 L600 320 H900 L980 390 H1460",
  "M-20 520 H420 L500 440 H760 L840 520 H1180 L1240 460 H1460",
  "M-20 710 H260 L340 630 H640 L720 710 H1080 L1140 650 H1460",
  "M200 -20 V120 L260 180 V420 L200 480 V920",
  "M620 -20 V70 L680 130 V360 L620 420 V640 L700 720 V920",
  "M1080 -20 V170 L1140 230 V520 L1080 580 V920",
  "M420 920 V760 L480 700 V470 L420 410 V250",
  "M900 920 V780 L960 720 V500 L900 440 V300 L960 240 V60",
  "M-20 60 H120 L190 130 H430 L500 60 H780",
  "M660 920 V860 L740 790 H1020 L1100 860 V920",
  "M-20 430 H90 L150 490 H330",
  "M1460 240 H1300 L1240 300 H1020 L960 360 H820",
  "M1460 800 H1320 L1260 740 H1040",
  "M300 -20 V40 L360 100 H540 L600 40 V-20",
  "M1240 920 V820 L1180 760 V600 L1240 540 V380",
  "M-20 880 H200 L280 800 H520",
];

const FINE = [
  "M0 240 H1440", "M0 610 H1440", "M520 0 V900", "M860 0 V900",
];

const NODES = [
  [300, 150], [620, 210], [1000, 130], [250, 400], [600, 320], [980, 390],
  [420, 520], [760, 440], [1180, 520], [340, 630], [720, 710], [1140, 650],
  [200, 120], [680, 130], [1140, 230], [480, 700], [960, 500],
];

const HOT = [[620, 210], [980, 390], [760, 440], [340, 630], [1140, 230]];

export const CircuitBg = () => (
  <div className="circuit-layer" aria-hidden="true">
    <svg viewBox="0 0 1440 900" preserveAspectRatio="none" className="w-full h-full">
      {FINE.map((d) => (
        <path key={`f-${d}`} d={d} className="circuit-fine" fill="none" strokeWidth="0.8" />
      ))}
      {TRACES.map((d) => (
        <path key={`t-${d.slice(0, 14)}`} d={d} className="circuit-trace" fill="none" strokeWidth="1.2" />
      ))}
      {TRACES.map((d, i) => (
        <path key={`p-${i}`} d={d} className="circuit-pulse" fill="none" strokeWidth="2"
          style={{ animationDuration: `${7 + (i % 5) * 2.4}s`, animationDelay: `${i * 1.3}s` }} />
      ))}
      {NODES.map(([x, y]) => (
        <circle key={`n-${x}-${y}`} cx={x} cy={y} r="4.5" className="circuit-node" strokeWidth="1.2" />
      ))}
      {HOT.map(([x, y], i) => (
        <circle key={`h-${x}-${y}`} cx={x} cy={y} r="2.4" className="circuit-node-hot"
          style={{ animationDelay: `${i * 0.7}s` }} />
      ))}
    </svg>
  </div>
);

export default CircuitBg;
